import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogoService {
  private basePath = '/api/v1/images/portfolio/';
  private typeImg = '.png';

  public logo = new ReplaySubject(0);

  constructor() {}

  public getPortfolioLogo(portfolioId: string | number | undefined): string | void {
    if (portfolioId) {
      const logoReturn = `${environment.image_server}` + this.basePath + portfolioId + this.typeImg;
      return logoReturn;
    }
  }
}
